import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreatePersonalTaskDto,
  PersonalTaskDto,
  UpdatePersonalTaskDto,
} from 'app/api/models/calendar/personalTaskDto';

const API = '/api/personal-tasks';

@Injectable({ providedIn: 'root' })
export class PersonalTaskService {
  constructor(private http: HttpClient) {}

  getMyTasks() {
    return this.http.get<PersonalTaskDto[]>(API);
  }

  create(dto: CreatePersonalTaskDto) {
    return this.http.post<PersonalTaskDto>(API, dto);
  }

  update(id: string, dto: UpdatePersonalTaskDto) {
    return this.http.patch<PersonalTaskDto>(`${API}/${id}`, dto);
  }

  toggleCompletion(id: string) {
    return this.http.post<PersonalTaskDto>(`${API}/${id}/toggle`, {});
  }

  delete(id: string) {
    return this.http.delete<void>(`${API}/${id}`);
  }
}
